const rolesWithId = {
  admin: "6720e9760ca50db671add43c",
  agent: "6720e9990ca50db671add43e",
  financialPlanner: "6720e9990ca50db671add43e", // Same as agent for now
};

// Plan duration constants (in months)
const PLAN_DURATIONS = {
  QUARTERLY: 3,
  HALF_YEARLY: 6,
  ANNUALLY: 12,
  BIENNIALLY: 24,
};

// Renewal types
const RENEWAL_TYPES = {
  QUARTERLY: "quarterly",
  HALF_YEARLY: "half_yearly",
  ANNUALLY: "annually",
  BIENNIALLY: "biennially",
};

// Plan type to default duration mapping
const PLAN_TYPE_DURATIONS = {
  basic: PLAN_DURATIONS.ANNUALLY,
  comprehensive: PLAN_DURATIONS.ANNUALLY,
  zeroToOne: PLAN_DURATIONS.QUARTERLY,
  wealthManagement: PLAN_DURATIONS.BIENNIALLY,
};

export { rolesWithId, PLAN_DURATIONS, RENEWAL_TYPES, PLAN_TYPE_DURATIONS };
